'use client'

import Image from 'next/image'
import s from './style.module.scss'
import useAddToHomescreenPrompt from '@app/components/header/sections/a2hs-button/use-add-to-home-screen'
import A2hsShimmer from './shimmer'
import {HeaderEvent} from '../../../analytics/events'
import triggerAnalytics from '@gamezop/analytics-sdk/client/trigger-analytics'
import clsx from 'clsx'

type Props = {
  text: string
}

const A2hsButtonClient = ({text}: Props) => {
  const {promptToInstall, showA2HS} = useAddToHomescreenPrompt()

  return (
    <div className={clsx(s.button_container, 'group')}>
      {showA2HS === undefined && <A2hsShimmer css={s.shimmer} />}
      {showA2HS && (
        <button
          className={s.button}
          onClick={() => {
            promptToInstall()
            triggerAnalytics(HeaderEvent.A2HSButtonClicked).sendAll()
          }}
        >
          <Image
            src='https://static.gamezop.com/comet/assets/img2/download-btn-white.svg'
            alt='add to home screen button'
            width={13}
            height={13}
            className='group-hover:animate-bounce'
          />
          <span className={s.text}>{text}</span>
        </button>
      )}
    </div>
  )
}

export default A2hsButtonClient
